import { IApplicationStyle } from '../models/index.js';
export const applicationStyle: IApplicationStyle = {
	font: {
		family: 'Arial',
	},
};
